import * as React from "react";
import { isLoading, isRejected } from "../../../../helpers";
import { Loader, FreeHtml } from "sb-resp-ui";
import { Remove } from "./../Remove";
const baseClass = "rj-yourbet__message";
export class Message extends React.Component {
    render() {
        const { modifier, label, type, handler } = this.props;
        const cls = baseClass + (modifier ? ` ${baseClass}--${modifier}` : "");
        return (React.createElement("div", { className: cls, "data-uat": `your-bet-status-${modifier}` },
            React.createElement("span", { className: "rj-yourbet__message-text", "data-uat": "your-bet-message-text" },
                React.createElement(FreeHtml, { html: label })),
            isLoading(type) && React.createElement(Loader, null),
            isRejected(type) && handler &&
                React.createElement(Remove, { modifier: "close", "data-uat": "yourbet-message-close", icon: "i-12 i-o-yourbet-close", handler: handler })));
    }
}
//# sourceMappingURL=Message.js.map